<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  stroke="currentColor"
  [ngClass]="{
    'size-10': size === 10,
    'size-9': size === 9,
    'size-8': size === 8,
    'size-7': size === 7,
    'size-6': size === 6,
    'size-5': size === 5,
    'size-4': size === 4,
    'size-3': size === 3,
  }"
>
  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
</svg>
